import React from 'react'
import { Button, Card, Space, theme } from 'antd'
import EscalatedSubmissionsTable, { escalatedStatuses } from './EscalatedSubmissionsTable'
import { FlagOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { useState } from 'react'
import ExportEscalatedSubmissionsButton from './ExportEscalatedSubmissionsButton'

const EscalatedSubmissionsCard = () => {
    const { token } = theme.useToken()
    const [filtersState, setFiltersState] = useState({})

    const toggleFiltersState = key => {
        setFiltersState({ ...filtersState, [key]: !filtersState[key] })
    }

    return (
        <Card
            className='mb-16'
            title='Escalated Submissions'
            extra={
                <Space>
                    <ExportEscalatedSubmissionsButton />
                    <Button
                        type={filtersState[escalatedStatuses.unexplainableUnresolved] ? 'primary' : 'text'}
                        onClick={() => {
                            toggleFiltersState(escalatedStatuses.unexplainableUnresolved)
                        }}
                        icon={
                            <QuestionCircleOutlined
                                style={{
                                    fontSize: 18,
                                    color: filtersState[escalatedStatuses.unexplainableUnresolved] ? token.colorTextLightSolid : token.colorText,
                                }}
                            />
                        }
                        title={'Unexplainable'}
                    />
                    <Button
                        type={filtersState[escalatedStatuses.manualUnresolved] ? 'primary' : 'text'}
                        onClick={() => {
                            toggleFiltersState(escalatedStatuses.manualUnresolved)
                        }}
                        icon={
                            <FlagOutlined
                                style={{
                                    fontSize: 18,
                                    color: filtersState[escalatedStatuses.manualUnresolved] ? token.colorTextLightSolid : token.colorText,
                                }}
                            />
                        }
                        title={'Flagged by user'}
                    />
                </Space>
            }
        >
            <EscalatedSubmissionsTable filtersState={filtersState} />
        </Card>
    )
}

export default EscalatedSubmissionsCard
